import React from "react";

import Panel from "../components/ergo-elements/components/Panel";
import LinkButton from "../components/LinkButton";
import I18n from "../i18n";

import { getCurrentLanguage } from "../LanguageHelper";
import { useParams } from "react-router-dom";

const style = {
  display: "flex",
  justifyContent: "flex-end",
  alignContent: "space-between",
  alignItems: "center",
  padding: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: 64,
  borderTop: "1px solid #D2D0CD",
  paddingRight: 47,
};

const Footer = (props) => {
  const { lang } = useParams();
  return (
    <Panel variant="tertiary" style={style}>
      Copyright © DKV Belgium
      <LinkButton href="mailto:hospital@dkv.be">
        <I18n keys="Support" />
      </LinkButton>
      <LinkButton target="_blank" href="https://www.dkv.be/privacy">
        <I18n keys="Privacy Policy" />
      </LinkButton>
      <LinkButton to={`/${getCurrentLanguage({ params: {lang} })}/cookies`}>
        <I18n keys="Cookies" />
      </LinkButton>
    </Panel>
  );
};

export default Footer;
